/* istanbul ignore file */

import { css } from 'styled-components';
export var visuallyHidden = /*#__PURE__*/css(["clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;"]);
export var hiddenWhenNoJS = /*#__PURE__*/css([".no-js &{display:none;}"]);
export var hiddenWhenJSExists = /*#__PURE__*/css([".js &{display:none;}"]);